module.exports = __webpack_public_path__ + "static/app-c65bfddc4181e053b463179ab454f05d.png";